module.exports = __webpack_public_path__ + "static/media/logo-nb.636ce40a.png";